import React from 'react';
import MarketMF from '../MarketMF';

function SIPCalculator() {

    function iframe() {
        return {
            __html: '<iframe src="sip-calculator.html" width="100%" height="650px" style="border:0; overflow:hidden"></iframe>'
        }
    }


    return (
        <>
            <div class="col-12 p-0 breadcrumMF ">
                <ul>
                    <li><a href="/">Home</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/market/mutual-funds">Mutual Fund</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li>SIP Calculator</li>
                </ul>
            </div>
            <div className='Fund-header'>
                <h2><span>SIP Calculator</span></h2>
            </div>
            <MarketMF optionValue="SIP Calculator" />
            <div>
                <div dangerouslySetInnerHTML={iframe()} />
            </div>
        </>
    )
}

export default SIPCalculator